export interface ISMSCommunicationKeyParams {
  customerPhoneNumber: string;
  filter?: {
    applicationID?: string;
    limit?: number;
  };
}

export const SMSCommunicationKeys = {
  root: (params: ISMSCommunicationKeyParams) =>
    ['SMSCommunication', params.customerPhoneNumber] as const,
  filter: (params: ISMSCommunicationKeyParams) =>
    [...SMSCommunicationKeys.root(params), params.filter] as const,
};

export function parseSMSCommunicationKey<
  T extends keyof typeof SMSCommunicationKeys
>(queryKey: ReturnType<(typeof SMSCommunicationKeys)[T]>) {
  const [, customerPhoneNumber, filter] = queryKey;
  return { customerPhoneNumber, filter };
}
